/* eslint react/jsx-props-no-spreading: 0 */ // --> OFF

import React from "react";
import { Checkbox } from "primereact/checkbox";
import Label from "../../Label";

export default function CheckboxPR({ id, label, field, ...props }) {
  return (
    <>
      <Checkbox {...field} id={id} {...props} />
      <Label htmlFor={id}>{label}</Label>
    </>
  );
}
